export default {
  getProfilePicture (profilePictureUrl, userId) {
    return profilePictureUrl || `/api/identicons/${userId}`
  }
}



// WEBPACK FOOTER //
// ./src/helpers/user.js